import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import tmpl from '@bingads-webui-component-legacy/form/template/sidebar/aggregate-length.pug';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!component/form');

export default class View extends Backbone.View {
  initialize({ properties = [], viewModel = {}, id } = {}) {
    const strProperties = properties.toString();

    this.srId = `${id}-TotalRemaining`;

    _.each(properties, (property) => {
      viewModel[property].describedby.push(this.srId);
    });

    this.viewModel = {
      remaining: viewModel[strProperties].remaining,
      remainingChar: ko.computed(() => {
        const remaining = viewModel[strProperties].remaining();
        const fields = _.reduce(properties, (initial, property) => {
          if (initial) {
            return i18n.get('TotalRemainingCharactersText_FieldsList', {
              initial,
              last: viewModel[property].label(),
            });
          } else {
            return viewModel[property].label();
          }
        });

        return i18n.get('TotalRemainingCharactersText', {
          count: remaining,
          fields,
        });
      }),
    };
  }

  render() {
    this.$el.html(tmpl({ srId: this.srId }));

    ko.applyBindings(this.viewModel, this.el);

    return this;
  }
}
